import { useEffect, useState } from 'react'

export interface THandleCountdownUpdate {
  (minutes: number): void
}
function getCountDownDate(initialMinutes: string): number {
  return new Date().getTime() + parseInt(initialMinutes) * 60 * 1000
}
export const useCountdown = (
  initialMinutes: string,
  handleCountdownUpdate?: THandleCountdownUpdate
) => {
  const [minutes, setMinutes] = useState(parseInt(initialMinutes))
  const [seconds, setSeconds] = useState(0)
  const [timerInProgress, setTimerInProgress] = useState(true)
  const [countDownDate, setCountDownDate] = useState(getCountDownDate(initialMinutes))

  useEffect(() => {
    setCountDownDate(getCountDownDate(initialMinutes))
  }, [initialMinutes])

  useEffect(() => {
    setTimerInProgress(true)
    const interval = setInterval(() => {
      const now = new Date().getTime()
      const timeRemaining = countDownDate - now

      const newMinutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
      const newSeconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

      setMinutes(newMinutes)
      setSeconds(newSeconds)

      if (timeRemaining < 0) {
        clearInterval(interval)
        setTimerInProgress(false)
      }

      handleCountdownUpdate && handleCountdownUpdate(newMinutes)
    }, 1000)

    return () => {
      clearInterval(interval)
      setTimerInProgress(false)
    }
  }, [handleCountdownUpdate, countDownDate, setMinutes, setSeconds, setTimerInProgress])

  return { minutes, seconds, timerInProgress }
}
